import isNumber from 'lodash/isNumber'

export default v => {
  if (isNumber(v)) {
    return `${v.toLocaleString()} ₽`
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/localPrice.js